import { createFileRoute, Navigate } from '@tanstack/react-router';

function OrgHome() {
  const { orgId } = Route.useParams();
  return <Navigate to="/o/$orgId/activity" params={{ orgId }} replace />;
}

/** `/o/$orgId`: the organisation's activity feed. */
export const Route = createFileRoute('/_auth/o/$orgId/')({
  component: OrgHome,
});
